import {Customer} from "../types";
import * as React from "react";

interface CustomerDisplayProps {
    customer: Customer;
    maxLines?: number;
}

export function CustomerDisplay({customer, maxLines}: CustomerDisplayProps) {
    const [line1, line2, line3] = getCustomerDisplayLines(customer).slice(0, maxLines);
    return (
        <div>
            <div><strong>{line1}</strong></div>
            {line2 && (
                <div>{line2}</div>
            )}
            {line3 && (
                <div>{line3}</div>
            )}
        </div>
    );
}

function getCustomerDisplayLines(customer: Customer) {
    const lines = [
        [customer.lastName, customer.firstName]
            .filter(namePart => namePart?.trim())
            .join(", "),
        customer.email,
        customer.phone
    ];
    return lines.filter(line => line?.trim());
}
